import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import editorFormMixin from 'next/javascripts/mixins/editor-form-mixin';
import editorDraftMixin from 'next/javascripts/mixins/editor-draft-mixin';
import resourceSubject from 'next/javascripts/reactivity/resource-subject';
import 'next/stylesheets/components/todo/desc-form.scss';

Component('tr-todo-desc-form', {
  mixins: [eventListenerMixin, editorFormMixin, editorDraftMixin],

  properties: {
    visible: {
      type: Boolean,
      default: false,
    },
  },

  ready() {
    this.textarea = this.querySelector('textarea');
    this.originalContent = this.textarea.value;
    this.editor = this.querySelector('tr-editor');

    this.listenTo(
      this.querySelector('.cancel-button'),
      'click',
      this.handleFormCancel.bind(this),
    );

    $(this).on('ajax:success', 'form', this.handleSubmitSuccess.bind(this));
  },

  disconnected() {
    this.stopListening();
  },

  handleSubmitSuccess(event, result) {
    resourceSubject('todo').next('update', {
      id: result.id,
      rowData: { desc: result.tableViewData.desc },
    });
    this.namespacedTrigger('submitted', { detail: result.desc, bubbles: true });
    this.visible = false;
    this.remove();
  },

  handleFormCancel() {
    const cancel = this.namespacedTrigger('cancel');
    if (cancel) this.cancel();
  },

  cancel() {
    this.visible = false;
    this.remove();
  },
});
